export default "__VITE_ASSET__DvCQMLKF__"